//-------------------
// store hidden cols
//-------------------
export default function storeHiddenCols(headings) {
  // console.log("-----------------------")
  // console.log("IN storeHiddenCols")
  let cols = [] 
  headings.forEach((e, idx) => {
    if (e.hidden == false) {
      cols.push(idx);
    }
  });

  return cols;
}
